import { useQueries } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';
import { Chunk } from '@/types';

export function useGetChunksBatch(matterId: string | null | undefined, chunkIds: string[]) {
  const { fetchConfigGET } = useGetFetchConfig();

  const results = useQueries(
    chunkIds.map((chunkId) => ({
      queryKey: [QueryEntity.Chunk, chunkId],
      queryFn: async (): Promise<Chunk> => {
        const response = await fetch(`${APIBaseChronos}/api/matters/${matterId}/chunks/${chunkId}`, fetchConfigGET);
        if (!response.ok) throw new Error('Failed to fetch chunk');
        return response.json();
      },
      enabled: !!matterId && !!chunkId,
      refetchOnWindowFocus: false,
    })),
  );

  const isLoading = results.some((r) => r.isLoading);
  const isError = results.some((r) => r.isError);
  const data = results.map((r) => r.data).filter((c): c is Chunk => !!c);

  return { isLoading, isError, data };
}
